import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import {LevelWithCamera} from "./LevelWithCamera";
import nunjucks from "nunjucks";
import {ThreeJSCameraOverlay} from "./ThreeJSCameraOverlay";
import {ADNEditor} from "./ADNEditor";
// import {GSDevTools} from "gsap/GSDevTools";

// gsap.registerPlugin(GSDevTools)

export class Level3 extends LevelWithCamera {

  constructor({cameraFeed, tooltipCallback, visionEngine}) {
    super(cameraFeed, $("#screen-2-LEVEL3 .camera-canvas").get(0), visionEngine);
    console.log("constructor level3 with cam")

    this.$screen = $("#screen-2-LEVEL3");
    this.currentStep = 1;
    this.tooltipCallback = tooltipCallback;

    this.changedADNCount = 0;
    this.changedADNCMaxCount = 3;
    this.lastScreenTimeout = null
    this.lastPageResetDelay = 5000; // ms before continuing after last step

    this.listenForPinch = false;

    this.selectedFaceFeatures = [];
    this.completedFaceFeatures = [];
    this.selectedAtLeastOne = false;
    this.cropCanvasStates = [];
    this.currentSelectedADN = null;

    this.zoomedOnFace = false;
    this.zoomTimeline = null;
    this.transitionTimeline = null;

    this.photoCaptureImage = null;

    this.lottieCountdown = this.$screen.find(".step-1 .countdown-container .lottie-animation").data('lottie');
    this.lottieHandZoomIn = this.$screen.find(".hand-zoom-in-animation .lottie-animation").data('lottie');
    this.lottieHandZoomOut = this.$screen.find(".hand-zoom-out-animation .lottie-animation").data('lottie');

    this.threeJsOverlay = new ThreeJSCameraOverlay({
      canvas: this.$screen.find(".camera-overlays-canvas")[0],
      cameraFeed: this.sharedCameraFeed.getCanvas()
    });

    this.enableCameraOverlay = false;
    this.selectedOverlay = 1;

    this.started = false;

    this.init();
  }

  init() {
    super.init();

    this.adnEditor = new ADNEditor("#adn-editor");
    this.adnEditor.nextStepCallback = (id) => this.adnSelected(id);

    // console.log(this.cameraCanvasEl);
    // this.cameraCanvasEl = $("#screen-2-LEVEL3 .camera-canvas").get(0);
    // this.cameraCanvasElCtx = this.cameraCanvasEl.getContext('2d');
    $(document).on('pinchout', (e, data) => this.onPinchOut(e, data));
  }

  start() {

    this.startCamera();
    // Fade in the camera and show step 1
    // TODO: handle showing things with timelines

    this.showCamera();
    this.goToStep(1);

    // For debugging:
    // this.selectedFaceFeatures = ["mouth", "nose", "forehead", "eye"];
    // this.goToStep(5);
    // this.threeJsOverlay.selectEffect("nose", 0, false)
    // this.threeJsOverlay.selectEffect("forehead", 0, true)
    // this.threeJsOverlay.scene.remove(this.threeJsOverlay.scene.children[3])

    this.started = true;
  }

  goToStep(stepId) {
    // TODO: This is only a basic temp transition between screens. We need to handle this correctly with timelines

    this.$screen.find(`.step`).removeClass("active");
    this.hideHandZoomAnimation();

    // We can also handle each step custom transitions here if needed
    // if (stepId === 3) {
    //   this.hideCamera(); // Hide background camera before we fadeout the step
    //
    //   // We'll zoom in on the face features again before going to next step
    //   this.transitionTimeline = gsap.timeline({
    //     onComplete: () => {
    //       // Activate next step screen
    //       this.$screen.find(`.step-3`).addClass("active");
    //       // Hide step 2 screen
    //       gsap.set(this.$screen.find(`.step-2`), {clearProps: "all"});
    //
    //       this.$screen.find(`.step-3 .actions-container .zoom-in`).removeClass("hidden");
    //       this.showHandZoomAnimation();
    //     }
    //   });
    //
    //   this.transitionTimeline.to(this.cropCanvasStates, {
    //     duration: 2,
    //     sx: (i) => this.cropCanvasStates[i].end.sx,
    //     sy: (i) => this.cropCanvasStates[i].end.sy,
    //     sw: (i) => this.cropCanvasStates[i].end.sw,
    //     sh: (i) => this.cropCanvasStates[i].end.sh,
    //     ease: "power2.in",
    //     onUpdate: () => {
    //       this.cropCanvasStates.forEach((state) => {
    //         state.ctx.clearRect(0, 0, state.dw, state.dh);
    //         state.ctx.drawImage(
    //           this.getCameraCanvas(),
    //           state.sx, state.sy, state.sw, state.sh,
    //           state.dx, state.dy, state.dw, state.dh
    //         );
    //       });
    //     },
    //   });
    //
    //   this.transitionTimeline.add(() => {
    //     this.currentStep = stepId;
    //     this.initStep();
    //   });
    //
    //   this.transitionTimeline.fromTo(this.$screen.find(`.step-3`),
    //     {
    //       autoAlpha: 0,
    //     },
    //     {
    //       autoAlpha: 1
    //     });
    //
    //   this.transitionTimeline.fromTo(this.$screen.find(`.step-3 .zones-container .zone-title, .step-3 .zones-container .zone-image`),
    //     {
    //       scale: 0,
    //       autoAlpha: 0,
    //     },
    //     {
    //       scale: 1,
    //       autoAlpha: 1,
    //       ease: "back.out",
    //       stagger: 0.1
    //     },
    //     "-=0.5");
    //
    //   this.transitionTimeline.fromTo(this.$screen.find(`.step-3 .text-bubble-a`),
    //     {
    //       autoAlpha: 0,
    //     },
    //     {
    //       autoAlpha: 1
    //     },
    //     "-=0.5");
    //
    // } else
    if (stepId === 4) {
      this.hideCamera(); // Hide background camera before we fadeout the step

      this.transitionTimeline = gsap.timeline({
        onComplete: () => {
          this.$screen.find(`.step-${stepId}`).addClass("active");

          // Hide step 2 screen
          gsap.set(this.$screen.find(`.step-2`), {clearProps: "all"});

          // Reset the zoom so we are at the correct state on the next screen
          this.sharedCameraFeed.zoomFactor = this.sharedCameraFeed.originalZoomFactor;
        }
      });

      this.transitionTimeline.add(() => app.audio.play("audio/MNS2_Int2.2 Invisibles_SFX/MNS2_ME_INT2.2_SFXzoomIn.mp3", 1, true))

      // this.transitionTimeline.to(this.$screen.find(`.step-${this.currentStep}`), {
      //   autoAlpha: 0
      // });

      this.transitionTimeline.set(this.$screen.find(`.step-4 .text-instructions-a`), {
        autoAlpha: 0,
      });

      // zoom on face
      this.transitionTimeline.to(this.cropCanvasStates, {
        duration: 1,
        sx: (i) => this.cropCanvasStates[i].end.sx,
        sy: (i) => this.cropCanvasStates[i].end.sy,
        sw: (i) => this.cropCanvasStates[i].end.sw,
        sh: (i) => this.cropCanvasStates[i].end.sh,
        ease: "power3.Out",
        onUpdate: () => {
          this.cropCanvasStates.forEach((state) => {
            state.ctx.clearRect(0, 0, state.dw, state.dh);
            state.ctx.drawImage(
              this.photoCaptureImage,
              state.sx, state.sy, state.sw, state.sh,
              state.dx, state.dy, state.dw, state.dh
            );
          });
        },
      });

      this.transitionTimeline.add(() => {
        this.currentStep = stepId;
        this.initStep();
      });

      this.transitionTimeline.to(this.$screen.find(`.step-${stepId}`), {
        autoAlpha: 1
      });

      this.transitionTimeline.fromTo(this.$screen.find(`.step-4 .text-instructions-a`),
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1
        },
        "-=0.5");

    } else if (stepId === 5) {

      this.enableCameraOverlay = true;

      this.$screen.find(`.step-5`).removeClass("first-try");
      this.$screen.find(`.step-5 .tooltip`).removeClass("shown");

      this.threeJsOverlay.selectEffect(this.selectedFaceFeatures[0], this.currentSelectedADN, this.completedFaceFeatures.length === this.changedADNCMaxCount);

      this.threeJsOverlay.play();
      this.showCamera();
      this.startMainCamera();

      this.transitionTimeline = gsap.timeline({
        onComplete: () => {
          this.$screen.find(`.step-${stepId}`).addClass("active");
        }
      });

      // Reset a few elements
      this.transitionTimeline.set(this.$screen.find(`.step-5 .tooltip`), {
        autoAlpha: 0
      });

      this.transitionTimeline.set(this.$screen.find(`.step-5 .retry-trigger-container`), {
        autoAlpha: 0
      });

      this.transitionTimeline.to(this.$screen.find(`.step-${this.currentStep}`), {
        autoAlpha: 0
      });


      this.transitionTimeline.add(() => {
        this.currentStep = stepId;
        this.initStep();
      });

      this.transitionTimeline.to(this.$screen.find(`.step-${stepId}`), {
        autoAlpha: 1
      });

    } else {

      this.transitionTimeline = gsap.timeline({
        onComplete: () => {
          this.$screen.find(`.step-${stepId}`).addClass("active");
        }
      });

      this.transitionTimeline.to(this.$screen.find(`.step-${this.currentStep}`), {
        autoAlpha: 0
      });

      this.transitionTimeline.add(() => {
        this.currentStep = stepId;
        this.initStep();
      });

      this.transitionTimeline.to(this.$screen.find(`.step-${stepId}`), {
        autoAlpha: 1
      });
    }
  }

  adnSelected(id) {
    console.log(this);
    this.currentSelectedADN = id;
    app.audio.play("audio/MNS2_Int2.2 Invisibles_SFX/MNS2_ME_INT2.2_SFXfiltre.mp3", 1, true)
    this.nextStep();
  }

  nextStep() {
    this.goToStep(this.currentStep + 1);
  }

  initStep() {

    if (this.currentStep !== 5) {
      this.threeJsOverlay.pause();
    }

    if (this.currentStep === 1) {
      console.log("init step 1")
      this.resetStep1();
    } else if (this.currentStep === 2) {
      console.log("init step 2")
      // Mode face features selector and zoom in
      if (!this.selectedAtLeastOne) {
        // Init step 2 only once as there is no need to init more than once
        // First time around, what we need to do is show the hand pin in animation and first zoom in on the camera
        // On the second pinch in, we take a copy of that zoomed image and proceed as before (show the face features and)

        this.$screen.find(`.step-2`).addClass("zooming");
        this.$screen.find(`.step-2 .zoom-in`).addClass("hidden");

        this.selectedFaceFeatures = [];
      } else {
        this.$screen.find(`.step-2`).removeClass("zooming");
        this.$screen.find(`.step-2 .zoom-in`).removeClass("hidden");
      }

      this.updateCompletedLandmarks();
      this.showHandZoomAnimation("in");

    } else if (this.currentStep === 4) {
      // Mode where we show cells types
      this.hideHandZoomAnimation();
      this.enableCameraOverlay = false;
      this.threeJsOverlay.pause();

    } else if (this.currentStep === 5) {

      this.changedADNCount++;
      console.log(this.currentSelectedADN);

      if (this.lastScreenTimeout !== null) {
        clearTimeout(this.lastScreenTimeout);
        this.lastScreenTimeout = null;
      }

      if (this.changedADNCount < this.changedADNCMaxCount) {

        // Let's reset the draggables in the background
        this.resetStep4();

        this.$screen.find(`.step-5`).addClass("first-try");

        this.lastScreenTimeout = setTimeout(() => {

          gsap.to(this.$screen.find(`.step-5 .retry-trigger-container`), {
            autoAlpha: 1
          });

          if (this.changedADNCount == 1) {
            this.tooltipCallback(true, 'last_screen_first_try').then(() => {
              // Reset step 2 zoom
              // action is done in the html on the button
            })
          } else {
            this.tooltipCallback(true, 'last_screen_second_try').then(() => {
              // Reset step 2 zoom
              // action is done in the html on the button
            })
          }

        }, this.lastPageResetDelay)
      } else {
        console.log(this.currentSelectedADN);
        this.lastScreenTimeout = setTimeout(() => {
          console.log(this.currentSelectedADN);

          gsap.to(this.$screen.find(`.seve-cta-container`), {autoAlpha: 1});
          app.setAdditionalToolsVisibility(false, false)

          this.tooltipCallback(true, `last_screen_last_try_${this.currentSelectedADN}`).then(() => {
            app.goToScreen(3);
          })
        }, this.lastPageResetDelay)
      }

    }
  }

  step1Picture() {
    this.$screen.find(".step-1 .camera-trigger-container").addClass("disabled");
    this.resetLandmarks();

    this.step1tl = gsap.timeline();

    // Make sure flash is reset
    this.step1tl.set(this.$screen.find(".step-1 .countdown-container .screen-flash"), {
      autoAlpha: 0,
    });

    this.step1tl.add(() => app.audio.play("audio/MNS2_Int2.2 Invisibles_SFX/MNS2_ME_INT2.2_SFXdecompte.mp3", 1, true))

    this.step1tl.fromTo(this.$screen.find(".step-1 .text-bubble, .step-1 .camera-trigger-container"), {
      autoAlpha: 1
    }, {
      autoAlpha: 0,
      duration: 0.25,
      ease: "quad.out",
    })

    this.step1tl.fromTo(this.$screen.find(".step-1 .countdown-container"), {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      duration: 0.25,
      ease: "quad.out",
    }, 0)

    // Trigger lottie animation
    this.step1tl.add(() => {
      this.lottieCountdown.setFrame(0)
      this.lottieCountdown.play();
    })

    this.step1tl.fromTo(this.$screen.find(".step-1 .countdown-container .lottie-animation"), {
      autoAlpha: 1
    }, {
      autoAlpha: 0,
      duration: 0.25,
      ease: "quad.out",
    }, "+=3")


    // Flash
    this.step1tl.set(this.$screen.find(".step-1 .countdown-container .screen-flash"), {
      autoAlpha: 1,
    });

    this.step1tl.add(() => app.audio.play("audio/MNS2_Int2.2 Invisibles_SFX/MNS2_ME_INT2.2_SFXphoto.mp3", 1, true))

    // Trigger photo
    this.step1tl.add(() => {
      this.pauseMainCamera(); // we pause the ACTUAL camera so we can easily zoom in on the face on the next step before freezing the image onto another canvas
    })

    this.step1tl.fromTo(this.$screen.find(".step-1 .countdown-container .screen-flash"), {
      autoAlpha: 1
    }, {
      autoAlpha: 0,
      duration: 0.25,
      ease: "quad.out",
    })

    // Trigger photo
    this.step1tl.add(() => {
      this.updateFaceLandmarks();
      this.faceLandmarks = this.getMainFaceLandmarksPoints();

      if (this.faceLandmarks.length === 0) {
        // No face detected, show a message and start over
        console.log("No face detected");
        this.tooltipCallback(true, 'no_face_tooltip').then(() => {
          // Reset a few things
          this.startMainCamera();

          this.resetStep1();
        })
      } else if (!this.isFaceCorrectSize() || !this.isFaceCorrectlyCentered()) {
        // Face is not centered correctly or too small/big, show a message and start over
        console.log("Face is not centered correctly or too small/big");

        // TODO: Display a different message in this case?
        this.tooltipCallback(true, 'no_face_tooltip').then(() => {
          // Reset a few things
          this.startMainCamera();

          this.resetStep1();
        })
      } else {
        // We got a face
        this.goToStep(2);
      }
    })

  }

  drawStep2CanvasSections() {
    // First take a screenshot of the actual canvas so it doesn't change when we go back to this step
    // const dataURL = this.getCameraCanvas().toDataURL("image/png");
    // this.$screen.find("#canvas-zone-1").attr("src", dataURL);
    createImageBitmap(this.getCameraCanvas()).then(bitmap => {
      this.photoCaptureImage = bitmap;

      this.$screen.find(".canvas-zone").each((i, el) => {
        const currentCtx = el.getContext('2d');
        currentCtx.clearRect(0, 0, el.width, el.height);

        const isBottom = i > 1;
        const isRight = (i % 2 === 1);

        // Get the image from the shared camera and draw it on our canvas
        currentCtx.drawImage(this.photoCaptureImage,
          (isRight ? el.width : 0), (isBottom ? el.height : 0), el.width, el.height,
          0, 0, el.width, el.height
        );
      });
    });
  }

  clearStep2CanvasSections() {
    console.log("clearStep2CanvasSections");

    this.$screen.find(".canvas-zone").each((i, el) => {
      const currentCtx = el.getContext('2d');
      currentCtx.clearRect(0, 0, el.width, el.height);
    });

    // this.$screen.find("#canvas-zone-1").attr("src", "");
  }

  generateFaceLandmarksSelectors() {
    for (const landmark of this.faceLandmarks) {
      const {name, x, y} = landmark;

      let targetX = (x * 1080);
      let targetY = (y * 1920);

      // Limit the position of the tags as they can be hidden by
      // the top text, the handcoach or screen sides
      targetX = Math.max(235, Math.min(860, targetX));

      if (name == "forehead") {
        // Forehead tag is really long in french so we'll limit it differently
        targetX = Math.max(295, Math.min(475, targetX));
        targetY = Math.max(415, targetY);
      }

      this.$screen.find(`.zone-selector[data-zone-id="${name}"]`).css({
        left: targetX + "px",
        top: targetY + "px",
      })
    }

  }

  updateCompletedLandmarks() {
    for (const part of this.completedFaceFeatures) {
      let $part = this.$screen.find(`.zone-selector[data-zone-id="${part}"]`);
      $part.addClass("completed");
    }
  }

  resetCameraZoom() {
    this.cropCanvasStates.forEach((state) => {
      state.ctx.clearRect(0, 0, state.dw, state.dh);
      state.ctx.drawImage(
        this.photoCaptureImage,
        state.dx, state.dy, state.dw, state.dh
      );
    });
  }

  redoStep2() {
    // We need to reset the zoom from step 2
    this.resetCameraZoom();

    app.audio.play("audio/MNS2_Communs_SFX/MNS2_ME_INT_SFXselection.mp3", 1, true)

    this.goToStep(2);
  }

  step2FirstZoomOnFace() {
    // Handle zoom in
    // We'll zoom the face a little bit and then compute the face features to get their new zoomed positions
    this.hideHandZoomAnimation();

    this.zoomedOnFace = true;

    this.zoomTimeline = gsap.timeline({
      onComplete: () => {
        // Add a small delay to make sure the zoom smoothing from the camera is completed
        setTimeout(() => {
          // update the landmarks to get the new zoomed ones
          this.updateFaceLandmarks();
          this.faceLandmarks = this.getMainFaceLandmarksPoints();
          this.generateFaceLandmarksSelectors();
          this.drawStep2CanvasSections();
          this.showHandZoomAnimation();

          this.$screen.find(`.step-2`).removeClass("zooming");
          this.$screen.find(`.step-2 .zoom-in`).removeClass("hidden");
        }, 100);
      }
    });

    // Directly change the zoom factor on the canvas camera to simulate the zoom
    // Let's compute how much do we need to scale to if we want to have the face the size we want from the settings
    let currentFaceWidth = this.sharedCameraFeed.latestScaledFaceBoundingBox.w;
    let targetWidth = this.sharedCameraFeed.height * app.settings.webcam.face_zoomed_screen_ratio;
    let zoomTarget = targetWidth / currentFaceWidth;

    this.zoomTimeline.add(() => app.audio.play("audio/MNS2_Int2.2 Invisibles_SFX/MNS2_ME_INT2.2_SFXzoomIn.mp3", 1, true))

    this.zoomTimeline.fromTo(this.sharedCameraFeed,
      {
        zoomFactor: this.sharedCameraFeed.originalZoomFactor,
      },
      {
        zoomFactor: this.sharedCameraFeed.originalZoomFactor + zoomTarget,
        duration: 1,
        ease: "quad.out"
      });

  }

  step2ZoomIn(part) {

    // We'll use the same base as level 1,
    this.selectedFaceFeatures = [part];
    this.selectedAtLeastOne = true;

    // handle left and right eyes
    if (part.includes("eye")) {
      part = "eye";
    }

    if (!this.completedFaceFeatures.includes(part)) {
      this.completedFaceFeatures.push(part);
    }

    // Let's start by hiding interface elements
    this.$screen.find(`.step-2`).addClass("zooming");
    this.$screen.find(`.step-2 .zoom-in`).addClass("hidden");
    this.hideHandZoomAnimation();

    // Let's get all the 4 points we have selected
    const targetPoints = this.selectedFaceFeatures.map((name) => {
      return this.faceLandmarks.find(point => point.name === name);
    })

    // Points will be assigned to a quadrant in the order they were chosen
    const endZoomFactor = 100;
    // Handle width and height seperately so we can keep the original ratio
    const endCropWidth = 1080 / endZoomFactor;
    const endCropHeight = 1920 / endZoomFactor;

    // Now let's create the base state for each points so we can zoom in on those points
    this.cropCanvasStates = targetPoints.map((point, i) => {
      const isBottom = i > 1;
      const isRight = (i % 2 === 1);

      const targetCanvas = this.$screen.find(".canvas-zone").eq(i).get(0);
      const targetContext = targetCanvas.getContext('2d');

      // Constrain X to make sure it keeps filling the screen
      const destinationX = (point.x * 1080) - (endCropWidth / 2);
      const constrainedX = constrain(destinationX, 0, (1080 - endCropWidth));

      return {
        ctx: targetContext,
        sx: isRight ? targetCanvas.width : 0,
        sy: isBottom ? targetCanvas.height : 0,
        sw: targetCanvas.width,
        sh: targetCanvas.height,
        dx: 0,
        dy: 0,
        dw: targetCanvas.width,
        dh: targetCanvas.height,
        // Here we can set the zoom destinations
        start: {
          sx: isRight ? targetCanvas.width : 0,
          sy: isBottom ? targetCanvas.height : 0,
          sw: targetCanvas.width,
          sh: targetCanvas.height,
        },
        end: {
          sx: constrainedX,
          sy: (point.y * 1920) - (endCropHeight / 2),
          sw: endCropWidth,
          sh: endCropHeight
        }
      };
    });

    // Here we can already prepare the step 3 selected feature
    // So the correct one is already shown when going to this step
    // Easiest way is to keep the same logic as level 3 and it will place the selected feature at first index
    // We can easily hide then others with css, same as level 3
    const orderMap = Object.fromEntries(this.selectedFaceFeatures.map((id, i) => [id, i]));

    // Sort with fallback for missing IDs
    const $sorted = this.$screen.find(".zones-container").children().sort(function (a, b) {
      const aId = $(a).data("zone-id").toString();
      const bId = $(b).data("zone-id").toString();

      // If the zone is not found in the selected features, we'll push it to the end of the array
      const aIndex = orderMap[aId] ?? Infinity;
      const bIndex = orderMap[bId] ?? Infinity;

      return aIndex - bIndex;
    });

    // Re-append the sorted elements back into the div
    this.$screen.find(".zones-container").append($sorted);


    // Now that everything is prepared, let's go to step 3 and fade in/out to the zoomed cell
    this.goToStep(4);
  }

  showHandZoomAnimation() {
    this.listenForPinch = true;
    this.$screen.find(`.hand-zoom-in-animation`).removeClass("hidden");
  }

  hideHandZoomAnimation() {
    this.listenForPinch = false;
    this.$screen.find(`.hand-zoom-in-animation`).addClass("hidden");
  }

  onPinchOut(e, data) {
    if (!this.listenForPinch) {
      return;
    }

    if (this.currentStep === 2) {
      // Handle zoom in for step 2
      if (!this.zoomedOnFace) {
        this.step2FirstZoomOnFace();
        console.log("zoom on face");
      } else {
        // We need to find the nearest face feature so we can zoom on the closest one
        const closestFaceFeature = this.findClosestFaceFeature(data.point);
        this.step2ZoomIn(closestFaceFeature);
      }

    } else {
      // TODO: Maybe handle this differently,
      //  but for now we'll simulate a click on the button that does the action on the current screen step
      let action = this.$screen.find(`.step-${this.currentStep} .actions-container .trigger:not(.hidden)`).data("pinch-action");
      this[action]();
    }
  }

  findClosestFaceFeature(point) {
    let closestFeature = null;
    let closestDistance = null;

    // We'll check the distance between our zoom point and the face features and find the closest one
    for (const landmark of this.faceLandmarks) {
      const {name, x, y} = landmark;

      // skip the point if it's already completed or if we are not tracking it and go to the closest one
      if (this.$screen.find(`.zone-selector[data-zone-id="${name}"]`).hasClass("completed") || this.$screen.find(`.zone-selector[data-zone-id="${name}"]`).length == 0) {
        // console.log("skipped", name);
        continue;
      }

      // console.log("checking", name);
      const distance = this.getDistance(point, {x: (x * 1080), y: (y * 1920)})

      if (closestDistance == null || distance < closestDistance) {
        closestDistance = distance;
        closestFeature = name;
      }
    }

    return closestFeature;
  }

  getDistance(p1, p2) {
    const dx = p2.x - p1.x;
    const dy = p2.y - p1.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  showCamera() {
    this.$screen.find(`.camera-canvas`).show();
  }

  hideCamera() {
    this.$screen.find(`.camera-canvas`).hide();
  }

  drawCameraOverlays() {
    if (!this.enableCameraOverlay) {
      return
    }

    // console.log("cam overlay");
    // Here we could add a distortion or mask on the face for example
    // this.faceLandmarks = this.getMainFaceLandmarksPoints();
    // this.generateFaceLandmarksSelectors();
    this.updateFaceLandmarks();
    this.threeJsOverlay.updateFaceLandmarks(this.latestLandmarks, this.getMainFaceLandmarksPoints());
  }

  resetStep1() {
    this.$screen.find(".step-1 .camera-trigger-container").removeClass("disabled");

    if (this.step1tl) {
      this.step1tl.revert();  // undoes all tweens + clears inline styles it set
      this.step1tl = null;
    }

    // revert() can leave screen-flash visible because the fromTo's cached
    // "from" value is autoAlpha:1. Force it back to hidden.
    gsap.set(this.$screen.find(".step-1 .countdown-container .screen-flash"), {clearProps: "all"});

    this.lottieCountdown.pause(0)
    this.lottieCountdown.setFrame(0)
  }

  resetStep2() {
    this.$screen.find(`.step-2`).removeClass("zooming");
    this.$screen.find(`.step-2 .actions-container .trigger`).addClass("hidden");
    this.$screen.find(`.step-2 .zone-selector`).removeClass("completed");

    if (this.zoomTimeline) {
      this.zoomTimeline.revert();  // undoes all tweens + clears inline styles it set
      this.zoomTimeline = null;
    }

    this.clearStep2CanvasSections();
  }

  resetStep3() {
    this.$screen.find(`.step-3`).removeClass("zooming");
  }

  resetStep4() {
    this.$screen.find(".adn-selector-container").removeClass("is-dragging");
    this.adnEditor.reset();
  }

  resetStep5() {
    this.$screen.find(`.step-5`).removeClass("first-try");
  }

  killTimeline(tl) {
    if (tl) {
      tl.pause();
      tl.seek(0);
      tl.kill()
      tl = null;
    }
  }

  reset() {
    if (!this.started) {
      return;
    }

    super.reset();

    this.currentStep = 1;
    this.selectedAtLeastOne = false;
    this.zoomedOnFace = false;

    this.faceLandmarks = [];
    this.currentSelectedADN = null;

    // Reset step 1
    this.resetStep1();
    this.resetStep2();
    this.resetStep3();
    this.resetStep4();
    this.resetStep5();

    this.photoCaptureImage = null;

    if (this.transitionTimeline) {
      this.transitionTimeline.revert();
      this.transitionTimeline = null;
    }

    this.changedADNCount = 0;

    this.selectedFaceFeatures = [];
    this.completedFaceFeatures = [];
    this.cropCanvasStates = [];

    this.$screen.find(`.actions-container .trigger`).addClass("hidden");
    this.$screen.find(`.step`).removeClass("active");

    gsap.set(this.$screen.find(`.seve-cta-container`), {autoAlpha: 0});

    this.hideHandZoomAnimation();
    this.enableCameraOverlay = false;
    this.threeJsOverlay.reset();

    if (this.lastScreenTimeout !== null) {
      clearTimeout(this.lastScreenTimeout);
      this.lastScreenTimeout = null;
    }

    // Clear all the transforms on the steps so they'll go back to initial state
    gsap.set(this.$screen.find(`.step`), {clearProps: "all"});
  }

}
